import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=3a28e52c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=3a28e52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a28e52c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a28e52c')) {
      api.createRecord('3a28e52c', component.options)
    } else {
      api.reload('3a28e52c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=3a28e52c&scoped=true&", function () {
      api.rerender('3a28e52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X887VMilv2M9/JS/comp/SearchFilterTokens.vue"
export default component.exports